import { MasterReducer, Generator } from '../../utils/store';
import { select, put } from 'redux-saga/effects';

import * as Functions from '../../utils/functions';

export const Reducer = new MasterReducer(
  'GalleryModal',
  {
    isOpen: false,
    payload: {},
    activedIndex: 0,
    activedItem: null,
    items: [],
  },
  {
    ...Generator.makePureActions('open', function* (returnAction, self) {
      const values = yield select(self.makeSelector('values'));
      var setPayload = {
        isOpen: true,
      };

      if (values) {
        const items = values.items.map(x => Functions.Filer.makeAdapterFile(x));
        const selectedItem = items.find(x => x.selected);
        const selectedIndex = selectedItem ? items.findIndex((x) => x.adapter.url === selectedItem.adapter.url) : 0;

        setPayload.activedIndex = selectedIndex;
        setPayload.items = items;
        setPayload.activedItem = items[selectedIndex];
      }

      yield put(self.actionCreators.setStates(setPayload));
    }),

    ...Generator.makePureActions('close', function* (returnAction, self) {
      yield put(self.actionCreators.setStates({
        isOpen: false,
      }));
    }),

    ...Generator.makePureActions('setActivedIndex', function* (returnAction, self) {
      const values = yield select(self.makeSelector('values'));
      const items = yield select(self.makeSelector('items'));
      const index = values.index;
      document.querySelector(`#GalleryModal-carousel-item-${index}`).scrollIntoView({
        behavior: 'smooth'
      });
      yield put(self.actionCreators.setStates({
        activedIndex: index,
        activedItem: items[index],
      }));
    }),

    ...Generator.makePureActions('nextIndex', function* (returnAction, self) {
      const activedIndex = yield select(self.makeSelector('activedIndex'));
      const items = yield select(self.makeSelector('items'));
      var setActivedIndex = 0;

      if (activedIndex < items.length - 1) {
        setActivedIndex = activedIndex + 1;
      }

      yield put(self.actionCreators.setActivedIndex({index: setActivedIndex}));
    }),

    ...Generator.makePureActions('backIndex', function* (returnAction, self) {
      const activedIndex = yield select(self.makeSelector('activedIndex'));
      const items = yield select(self.makeSelector('items'));
      var setActivedIndex = items.length - 1;

      if (activedIndex > 0) {
        setActivedIndex = activedIndex - 1;
      }
      
      yield put(self.actionCreators.setActivedIndex({index: setActivedIndex}));
    }),
  }
);

export default Reducer;

export const reducer = Reducer.reducer;
export const saga = Reducer.saga;